import { render, staticRenderFns } from "./PasswordSetting.vue?vue&type=template&id=94f9eadc&scoped=true"
import script from "./PasswordSetting.vue?vue&type=script&lang=js"
export * from "./PasswordSetting.vue?vue&type=script&lang=js"
import style0 from "./PasswordSetting.vue?vue&type=style&index=0&id=94f9eadc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94f9eadc",
  null
  
)

export default component.exports